import React from 'react'
import PropTypes from 'prop-types'
import {
  Row, Col, Select, Input, LabelWrapper, Button,
  Alert,
} from 'shpmtcd'

const { Option } = Select

const countryFilter = (input, option) => (
  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
)

class AddressForm extends React.Component {
  renderAddressFields = (formData) => {
    const {
      states,
      onSelectChange,
      onTextFieldChange,
      formErrors,
    } = this.props
    switch (formData.country) {
      case 'IN':
        return (
          <>
            <Row>
              <Col span={24}>
                <Input
                  id='street'
                  label='Address'
                  value={formData.street}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.street}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24}>
                <Input
                  label='Landmark (optional)'
                  id='landmark'
                  value={formData.landmark}
                  onChange={(e) => onTextFieldChange(e)}
                />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Input
                  label='City'
                  id='city'
                  value={formData.city}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.city}
                />
              </Col>
              <Col span={12}>
                <Input
                  label='Post code'
                  id='postCode'
                  type='number'
                  value={formData.postCode}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.postCode}
                />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <LabelWrapper label='State / Province' error={formErrors.state}>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder='Select a State'
                    id='state'
                    value={formData.state ? formData.state : 'Please select a state'}
                    onChange={
                      (value) => onSelectChange(value, 'state')
                    }
                  >
                    {
                    states.map((state) => (
                      <Option
                        key={state.name}
                        value={state.code}
                      >{state.name}
                      </Option>
                    ))
                  }
                  </Select>
                </LabelWrapper>
              </Col>
            </Row>
          </>
        )
      case 'SG':
        return (
          <>
            <Row>
              <Col span={24}>
                <Input
                  id='street'
                  label='Address'
                  value={formData.street}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.street}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24}>
                <Input
                  label='Post code'
                  id='postCode'
                  type='number'
                  value={formData.postCode}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.postCode}
                />
              </Col>
            </Row>
          </>
        )
      case 'HK':
        return (
          <>
            <Row>
              <Col span={24}>
                <Input
                  id='street'
                  label='Address'
                  onChange={(e) => onTextFieldChange(e)}
                  value={formData.street}
                  error={formErrors.street}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24}>
                <Input
                  label='District'
                  id='district'
                  value={formData.district}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.district}
                />
              </Col>
            </Row>
          </>
        )
      case 'AE':
        return (
          <>
            <Row>
              <Col span={24}>
                <Input
                  id='street'
                  label='Address'
                  onChange={(e) => onTextFieldChange(e)}
                  value={formData.street}
                  error={formErrors.street}
                />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Input
                  label='City'
                  id='city'
                  value={formData.city}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.city}
                />
              </Col>
              <Col span={12}>
                <Input
                  label='PO Box Number (optional)'
                  id='postBox'
                  value={formData.postBox}
                  onChange={(e) => onTextFieldChange(e)}
                />
              </Col>
            </Row>
          </>
        )
      default:
        return (
          <>
            <Row>
              <Col span={24}>
                <Input
                  id='street'
                  label='Address'
                  value={formData.street}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.street}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24}>
                <Input
                  label='City'
                  id='city'
                  value={formData.city}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.city}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24}>
                <Input
                  label='Post code'
                  id='postCode'
                  value={formData.postCode}
                  onChange={(e) => onTextFieldChange(e)}
                  error={formErrors.postCode}
                />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <LabelWrapper label='State / Province' error={formErrors.state}>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder='Select a State'
                    id='state'
                    value={formData.state ? formData.state : 'Please select a state'}
                    onChange={
                  (value) => onSelectChange(value, 'state')
                }
                  >
                    {
                  states.map((state) => <Option key={state.name}>{state.name}</Option>)
                }
                  </Select>
                </LabelWrapper>
              </Col>
            </Row>
          </>
        )
    }
  }

  render() {
    const {
      countries,
      onCancel,
      mode,
      formData,
      formErrors,
      onTextFieldChange,
      onSelectChange,
      countryCode,
      setPhoneCode,
      addAddress,
      fetchAllStates,
      resetState,
      showAddressErrorMessage,
      addressErrorMessage,
    } = this.props

    return (
      <section className='customer-address'>
        { mode === 'new' ? <h3>New Address</h3> : <h3>Edit Address</h3>}
        <Row gutter={16}>
          <Col span={12}>
            <Input
              label='First name'
              id='firstName'
              value={formData.firstName}
              onChange={(e) => onTextFieldChange(e)}
              error={formErrors.firstName}
            />
          </Col>
          <Col span={12}>
            <Input
              label='Last name'
              id='lastName'
              value={formData.lastName}
              onChange={
                (e) => onTextFieldChange(e)
              }
              error={formErrors.lastName}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <LabelWrapper label='Shipping Country'>
              <Select
                showSearch
                style={{ width: '100%' }}
                defaultValue={formData.country}
                placeholder='Select Country'
                id='country'
                onChange={
                  (value) => {
                    onSelectChange(value, 'country')
                    resetState()
                    fetchAllStates(value)
                    setPhoneCode(countries, value)
                  }
                }
                filterOption={countryFilter}
              >
                {
                  countries.map((country) => <Option key={country.code}>{country.name}</Option>)
                }
              </Select>
            </LabelWrapper>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Input
              prefix={<span className='prefixText'>{countryCode}</span>}
              label='Phone number'
              id='phone'
              type='number'
              value={formData.phone}
              onChange={
                (e) => onTextFieldChange(e)
              }
              error={formErrors.phone}
            />
          </Col>
        </Row>
        {this.renderAddressFields(formData)}
        <Row>
          <Col span={24} className='text-align--center'>
            <hr className='row-spacing--sm' />
            <div>
              <Button onClick={() => onCancel()} style={{ marginRight: '10px' }}>Cancel</Button>
              <Button
                type='Primary'
                onClick={() => addAddress()}
              >Save
              </Button>
            </div>
          </Col>
        </Row>
        {
          showAddressErrorMessage
          && (
            <Row>
              <Col span={24}>
                <div className='address-error-message'>
                  <Alert type='error' message={addressErrorMessage} showIcon />
                </div>
              </Col>
            </Row>
          )
        }
      </section>
    )
  }
}

AddressForm.propTypes = {
  states: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelectChange: PropTypes.func.isRequired,
  onTextFieldChange: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    postCode: PropTypes.number,
    state: PropTypes.string,
    district: PropTypes.string,
  }).isRequired,
  mode: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  setPhoneCode: PropTypes.func.isRequired,
  addAddress: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  fetchAllStates: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
  showAddressErrorMessage: PropTypes.bool.isRequired,
  addressErrorMessage: PropTypes.string,
  countries: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    phone_code: PropTypes.string.isRequired,
  })).isRequired,
  formData: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    street: PropTypes.string,
    landmark: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
    postCode: PropTypes.string,
    postBox: PropTypes.string,
    phone: PropTypes.string,
    district: PropTypes.string,
  }),
}

AddressForm.defaultProps = {
  formData: {
    id: '',
    firstName: '',
    lastName: '',
    street: '',
    landmark: '',
    city: '',
    state: '',
    country: '',
    postCode: '',
    postBox: '',
    phone: '',
    district: '',
  },
  addressErrorMessage: '',
}

export default AddressForm
